import { HTTP } from '../../http-common';
import { createHelpers } from 'vuex-map-fields';
import { httpError } from '../../models/httpError';
import { getField, updateField } from 'vuex-map-fields';

const state = {
  pbxDomains: [],
  message: new httpError(),
};

const getters = {
  message: state => {
    state.message;
  },
  pbxDomains: state => {
    return state.pbxDomains;
  },
  getField,
};

const mutations = {
  SET_PROGRESS(state, message) {
    state.message = message;
  },
  SET_PBX_DOMAINS(state, data) {
    state.pbxDomains = data;
  },
  updateField,
};

const actions = {
  setMessage({ commit }, message) {
    commit('SET_PROGRESS', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('SET_PROGRESS', new httpError());
      }, 2000);
  },
  async getPbxDomains({ dispatch, commit }, paging) {
    try {
      let result = await HTTP.post('pbx/GetPbxAccess', paging);
      commit('SET_PBX_DOMAINS', result.data);
      dispatch(
        'setMessage',
        new httpError({ message: 'Retreived OK', httpStatus: 200 })
      );
      return Promise.resolve(result.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async upsertPbxAccess({ dispatch }, payload) {
    try {
      let result = await HTTP.post('pbx/UpsertPbxAccess', {
        pbxAccess: payload,
      });
      dispatch(
        'setMessage',
        new httpError({ message: 'Update OK', httpStatus: 200 })
      );
      return Promise.resolve(result.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
};

export const { mapFields: mapPbxDomainsFields } = createHelpers({
  getterType: `pbxDomains/getField`,
  mutationType: `pbxDomains/updateField`,
});
export const { mapMultiRowFields: mapPbxDomainsMultiRowFields } = createHelpers(
  {
    getterType: 'pbxDomains/getField',
    mutationType: 'pbxDomains/updateField',
  }
);

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
